<div class="cx-order-overview-card border border-dark">
  <div class="col-12">
    <h3 class="text-left font-weight-bold">
      {{'orderHistory.itemsSummary' | cxTranslate}}
    </h3>
    <cx-order-details-items></cx-order-details-items>
    <div class="row">
      <div class="col-12 text-md-right">
        @if (orderDetails | async; as order) {
          <a [routerLink]="{ cxRoute: 'ticketsCode',
                params: {
                  code: order?.customerOrderReference,
                  mail: order?.customer?.contactEmail
                  }
                } | cxUrl"
          class="btn btn-primary mt-4"
          >
          <app-custom-icons [type]="iconType.EDIT">&nbsp;</app-custom-icons>
          {{ 'orderHistory.actions.invoices' | cxTranslate }}
        </a>
        <button type="button" (click)="repeatOrder(order?.customerOrderReference)"
          class="btn btn-green-olive text-bold repeat-order mt-4">
          <app-custom-icons [type]="iconType.ICON_REPEAT"></app-custom-icons>
          {{ 'orderHistory.actions.repeatOrder' | cxTranslate }}
        </button>
      }
    </div>
  </div>
</div>
</div>


